import { useCurrentShopSuspense } from "@/api/shops/use-current-shop-suspense.ts";
import { useShopFlag } from "@/hooks/use-flag.ts";
import { useViewerHasAtLeastCustomerSupportRights } from "@/lib/rights/use-viewer-has-right.ts";
import useViewerRole from "@/lib/rights/use-viewer-role.ts";
import useTranslation from "@babackapp/translations/use-translation";
import { GiftIcon, SparklesIcon } from "@heroicons/react/24/solid";
import { HomeIcon } from "@radix-ui/react-icons";
import {
  AlignEndHorizontal,
  BarChart3,
  GridIcon,
  ReplyIcon,
  Ruler,
} from "lucide-react";
import { NavigationSectionItem } from "./section.tsx";

export default function PrimaryNavigation() {
  const { data: shop } = useCurrentShopSuspense();
  const t = useTranslation();
  const isAskEnabled = useShopFlag("isAskEnabled");
  const isOperationalDashboardEnabled = useShopFlag(
    "isOperationalDashboardEnabled",
  );
  const isSizingEnabled = useShopFlag("isSizingEnabled");
  const hasAtLeastCustomerSupportRight =
    useViewerHasAtLeastCustomerSupportRights();
  const viewerRole = useViewerRole();
  const isLogistician = viewerRole === "logistician";

  if (!shop) return null;

  const navigation = [
    {
      name: t("sidebar.home"),
      href: `/shops/${shop.id}`,
      icon: <HomeIcon className="w-4 h-4" />,
      display:
        !isLogistician || shop.preferences.showHomeToLogistician !== false,
    },
    {
      name: t("sidebar.returns"),
      href: `/shops/${shop.id}/returns`,
      icon: <ReplyIcon className="w-4 h-4" />,
      display: true,
    },
    {
      name: t("sidebar.analytics"),
      href: `/shops/${shop.id}/analytics`,
      icon: <BarChart3 className="w-4 h-4" />,
      display:
        !isLogistician ||
        shop.preferences.showReturnRateToLogistician !== false,
      badge: "New",
    },
    {
      name: t("sidebar.sizing"),
      href: `/shops/${shop.id}/analytics/sizing`,
      icon: <Ruler className="w-4 h-4" />,
      display: isSizingEnabled,
    },
    {
      name: t("sidebar.operational"),
      href: `/shops/${shop.id}/operations`,
      icon: <AlignEndHorizontal className="w-4 h-4" />,
      display: isOperationalDashboardEnabled,
    },
    {
      name: t("sidebar.ask"),
      href: `/shops/${shop.id}/ask`,
      icon: <SparklesIcon className="w-4 h-4" />,
      display: isAskEnabled,
    },
    {
      name: t("sidebar.giftCode"),
      href: `/shops/${shop.id}/gift-codes`,
      icon: <GiftIcon className="w-4 h-4" />,
      display: shop?.giftCode?.activated ?? false,
    },
    {
      name: t("sidebar.automations"),
      href: `/shops/${shop.id}/workflows`,
      icon: <GridIcon className="w-4 h-4" />,
      display: hasAtLeastCustomerSupportRight,
    },
  ].filter((navItem) => navItem.display);

  return (
    <>
      {navigation.map((navItem) => (
        <NavigationSectionItem
          key={navItem.name}
          to={navItem.href}
          label={navItem.name}
          icon={navItem.icon}
          badge={navItem.badge}
        />
      ))}
    </>
  );
}
